import { TeamMember } from "@/api/team.api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExtendedListChildComponentProps } from "@/components/core/InfiniteScrollList/VirtualizedList";
import { ROLES } from "@/common/permissions";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getDeleteMemberTemplate } from "@/consts/team.consts";
import { SUPPORT_ACCORDION_SECTIONS } from "@/consts/support.consts";
import { CompactLocationBadges } from "@/components/blocks/CompactLocationBadges";

interface TeamMemberCardProps extends ExtendedListChildComponentProps {}

export function TeamMemberCard({ style, data, ref }: TeamMemberCardProps) {
  const navigate = useNavigate();

  if (!data) {
    return <div style={style} className="px-4" ref={ref} />;
  }

  const member = data as TeamMember;
  const isManager = member.role?.toLowerCase() === ROLES.MANAGER.toLowerCase();

  const roleName = isManager ? ROLES.MANAGER : ROLES.WAITER;
  const badgeVariant = isManager ? "default" : "outline";

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    navigate("/support", {
      state: {
        initialFormState: {
          description: getDeleteMemberTemplate({
            firstName: member.firstName,
            lastName: member.lastName,
            role: roleName,
          }),
        },
        expandAccordion: SUPPORT_ACCORDION_SECTIONS.REPORT_ISSUE,
      },
    });
  };

  return (
    <div style={style}>
      <Card
        className="transition-colors p-0"
        ref={ref}
      >
        <CardContent className="flex items-center gap-2 p-4">
          <div className="flex-1 min-w-0 space-y-1">
            <p className="text-sm font-medium leading-none truncate">
              {member.firstName} {member.lastName}
            </p>
            {member.locationNames && member.locationNames.length > 0 && (
              <CompactLocationBadges locationNames={member.locationNames} />
            )}
          </div>

          <Badge variant={badgeVariant}>
            {roleName}
          </Badge>

          <Button
            variant="link"
            size="icon"
            onClick={handleDelete}            
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

